export class FormatterFactory {
    constructor(className, params) {

        switch (className) {
            case "NumberFormatter":
                if (params.length > 0) {
                    return new Intl.NumberFormat(...params);
                }

                return new Intl.NumberFormat();
            case "YearFormatter":
                return new YearFormatter;
            default:
                throw "Invalid Formatter Class";
        }
    }
}

class YearFormatter {
    format(value) {
        return value;
    }
}
